import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import Add_Website from "./Add_Website";
import Edit_Website from "./Edit_Website";
import { API_BASE_URL } from "../../api";
import moment from "moment";
import Skeleton from "react-loading-skeleton"; // Import the Skeleton component

const Website_Comp = () => {
  const [websites, setWebsites] = useState([]);
  const [filteredWebsites, setFilteredWebsites] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedWebsite, setSelectedWebsite] = useState(null);
  const [activeTab, setActiveTab] = useState("card");
  const [loading, setLoading] = useState(true); // Loading state

  // Fetch websites from the API on mount
  useEffect(() => {
    const fetchWebsites = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/website`, {
          headers: {
            authorization: `Bearer ${localStorage.getItem("authToken")}`,
            user_id: localStorage.getItem("userId"),
          },
        });
        setWebsites(response.data);
        setFilteredWebsites(response.data);
        setLoading(false); // Set loading to false once data is fetched
      } catch (error) {
        console.error("Error fetching websites:", error);
        if (error.response?.status === 429) {
          // Handle Too Many Requests
          Swal.fire("Error", "Too many login attempts. Please try again later.", "error");
          window.location.href = "/"; // Redirect to the login page
          return;
        }
        if (error.response?.status === 401) {
          // Unauthorized error
          Swal.fire("Session Expired", "Please log in again.", "warning").then(() => {
            localStorage.removeItem("authToken"); // Clear auth token
            localStorage.removeItem("userId"); // Clear user ID
            window.location.href = "/"; // Redirect to login page
          });
        } else {
          // Other errors
          Swal.fire("Error", "Failed to fetch websites. Please try again.", "error");
        }
        setLoading(false); // Set loading to false in case of error
      }
    };
    fetchWebsites();
  }, []);

  // Handle search query updates
  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filtered = websites.filter((website) =>
      website.websiteurl.toLowerCase().includes(query) ||
      (website.remarks && website.remarks.toLowerCase().includes(query)) ||
      (website.mail && website.mail.toLowerCase().includes(query)) ||
      (website.domain_renewal_date && website.domain_renewal_date.toLowerCase().includes(query)) ||
      (website.invoice_renewal_date && website.invoice_renewal_date.toLowerCase().includes(query))
    );
    setFilteredWebsites(filtered);
  };

  const handleEditClick = (website) => {
    setSelectedWebsite(website);
  };

  const handleDeleteClick = (websiteId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`${API_BASE_URL}/api/website/${websiteId}`, {
          headers: {
            authorization: `Bearer ${localStorage.getItem("authToken")}`,
            user_id: localStorage.getItem("userId"),
          },
        })
          .then(() => {
            Swal.fire('Deleted!', 'The website has been deleted.', 'success');
            const updatedWebsites = websites.filter(w => w.id !== websiteId);
            setWebsites(updatedWebsites);
            setFilteredWebsites(updatedWebsites);
          })
          .catch((error) => {
            Swal.fire('Error!', 'There was an issue deleting the website.', 'error');
            console.error("Error deleting website:", error);
          });
      } else {
        Swal.fire('Cancelled', 'The website was not deleted.', 'info');
      }
    });
  };

  const toCamelCase = (str) => {
    if (!str) return "";
    const camelCased = str.replace(/_([a-z])/g, (match, group1) => group1.toUpperCase());
    return camelCased.charAt(0).toUpperCase() + camelCased.slice(1);
  };




  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    setCurrentPage(1);
  }, [search,itemsPerPage]);

  const filteredData = websites.filter((website) =>
    website.websiteurl.toLowerCase().includes(search) ||
    (website.remarks && website.remarks.toLowerCase().includes(search)) ||
    (website.mail && website.mail.toLowerCase().includes(search)) ||
    (website.domain_renewal_date && website.domain_renewal_date.toLowerCase().includes(search)) ||
    (website.invoice_renewal_date && website.invoice_renewal_date.toLowerCase().includes(search))
  );

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = filteredData.slice(startIndex, startIndex + parseInt(itemsPerPage));
  // console.log(startIndex);
  // console.log(startIndex + parseInt(itemsPerPage));


  return (
    <div className="content">
      {/* Breadcrumb */}
      <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
        <div className="my-auto mb-2 text-start">
          <div className="pagetitle">
            <h1>Website</h1>
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="javascript:void(0)">Home</a>
                </li>
                <li className="breadcrumb-item">Website</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
          <div className="d-flex align-items-center border bg-white rounded p-1 me-2 icon-list">
            <ul className="nav nav-tabs">
              <li className="">
                <button
                  className={`nav-link ${activeTab === "card" ? "active" : ""}`}
                  onClick={() => setActiveTab("card")}
                >
                  <i className="fa fa-th"></i>
                </button>
              </li>
              <li className="">
                <button
                  className={`nav-link ${activeTab === "table" ? "active" : ""} `}
                  onClick={() => setActiveTab("table")}
                >
                  <i className="fa fa-list"></i>
                </button>
              </li>
            </ul>
          </div>
          <div className="mb-2">
            <a
              href="#"
              data-bs-toggle="modal"
              data-bs-target="#add_website"
              className="btn btn-primary d-flex align-items-center">
              <i className="ti ti-circle-plus me-2"></i>Add Website
            </a>
          </div>
        </div>
      </div>


      {/* Active Tab Content */}
      {loading ? (
        <div className="row">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="col-xl-3 col-lg-4 col-md-6">
              <div className="card">
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div></div>
                    <div className="dropdown">
                      <button className="btn btn-icon btn-sm rounded-circle" type="button">
                        <i className="fa fa-ellipsis-v"></i>
                      </button>
                    </div>
                  </div>
                  <div className="text-center mb-3">
                    <div className="skeleton-text skeleton-loader skeleton-text-small"></div>
                    <div className="skeleton-text  skeleton-loader skeleton-text-small"></div>
                  </div>
                  <div>
                    <p className="mb-2 text-truncate">
                      <span className="skeleton-text skeleton-text-small"></span>
                    </p>
                    <p className="mb-2 text-truncate">
                      <span className="skeleton-text skeleton-text-small"></span>
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-top pt-3 mt-3">
                    <div className="ellips_1">
                      {/* <p className="mb-1 fs-12">Company</p> */}
                      <div className="skeleton-text  skeleton-loader skeleton-text-small"></div>
                    </div>
                    <div className="email ellips_1">
                      {/* <p className="mb-1 fs-12">Email</p> */}
                      <div className="skeleton-text skeleton-loader skeleton-text-small"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : activeTab === "card" ? (
        <div>

          {/* Search Bar */}
          <div className="card mb-3">
            <div className="card-body">
              <input
                type="text"
                className="form-control"
                placeholder="Search by URL, remarks, or email"
                value={searchQuery}
                onChange={handleSearch}
              />
            </div>
          </div>

          <div className="row">
            {filteredWebsites.length > 0 ? (
              filteredWebsites.map((website) => (
                <div className="col-xxl-3 col-lg-4 col-md-6" key={website.id}>
                  <div className="card">
                    <div className="card-body text-start">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h6>
                          URL : <a href={`http://${website.websiteurl}`} target="_blank" rel="noopener noreferrer">
                            {website.websiteurl}
                          </a>
                        </h6>
                        <div className="dropdown">
                          <a
                            href="#"
                            className="d-inline-flex align-items-center"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i className="fa fa-ellipsis-v"></i>
                          </a>
                          <ul className="dropdown-menu dropdown-menu-end p-3">
                            <li>
                              <a
                                href="#"
                                className="dropdown-item rounded-1"
                                data-bs-toggle="modal"
                                data-bs-target="#edit_website"
                                onClick={() => handleEditClick(website)}
                              >
                                <i className="ti ti-edit me-2"></i>Edit
                              </a>
                            </li>
                            <li>
                              <a
                                href="#"
                                className="dropdown-item rounded-1"
                                onClick={() => handleDeleteClick(website.id)}
                              >
                                <i className="ti ti-trash me-1"></i>Delete
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      {/* <div className="mb-3 pb-3 border-bottom ellips_1">
                <p className="text-truncate line-clamp-3 mb-0" title={website.remarks}>
                  {toCamelCase(website.remarks)}
                </p>
              </div> */}

                      <div className="d-flex align-items-center justify-content-between mb-3 pb-3 border-bottom">
                        <div>
                          <h6 className="fw-normal fs-12"><a href="#">Domain Renewal Date</a></h6>
                          <span className="fs-12 fw-normal">{website.domain_renewal_date}</span>
                        </div>
                        <div>
                          <h6 className="fw-normal fs-12"><a href="#">Invoice Renewal Date</a></h6>
                          <p className="mb-0 fs-12">{website.invoice_renewal_date}</p>
                        </div>
                      </div>

                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <h6 className="fw-normal fs-12"><a href="#">Email ID</a></h6>
                          <a href={`mailto:${website.mail}`}>
                            <span className="fs-12 fw-normal ellips_1" title={website.mail}>
                              {website.mail}
                            </span>
                          </a>
                        </div>
                        <div>
                          <h6 className="fw-normal fs-12"><a href="#">Server</a></h6>
                          <p className="mb-0 fs-12">{website.server}</p>
                        </div>
                      </div>

                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <p><small>Status: </small><span className={`badge bg-${website.status}`}>{toCamelCase(website.status)}</span></p>
                        </div>
                      </div>

                      {website.domain_renewal_date < moment().add(1, 'months').format("YYYY-MM-DD") ? (
                        <div className="d-flex align-items-center justify-content-between">
                          <div>
                            <p><small>Domain Due: </small><span className={`badge bg-inactive`}>{toCamelCase(website.domain_renewal_date)}</span></p>
                          </div>
                        </div>) : ''
                      }
                      {website.invoice_renewal_date < moment().add(1, 'months').format("YYYY-MM-DD") ? (
                        <div className="d-flex align-items-center justify-content-between">
                          <div>
                            <p><small>Invoice Due: </small><span className={`badge bg-inactive`}>{toCamelCase(website.invoice_renewal_date)}</span></p>
                          </div>
                        </div>) : ''
                      }


                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No websites found.</p>
            )}
          </div>
        </div>
      ) : (

        <div className="table-responsive custom-datatable-filter">
          <div className="row mt-2 justify-content-between mb-3">
            <div className="d-flex justify-content-between align-items-center dt-layout-start col-md-auto me-auto">
              <label htmlFor="dt-length-0"> entries per page</label>
              <select aria-controls="datatable" className="form-select form-select-sm" id="dt-length-0" value={itemsPerPage}
                onChange={(e) => setItemsPerPage(e.target.value)}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              </div>
            <div className="d-md-flex justify-content-between align-items-center dt-layout-end col-md-auto ms-auto">
              <label htmlFor="dt-search-0" className="form-label me-2 visually-hidden">Search:</label>
              <input
                type="text"
                placeholder="Search..."
                className="p-2 border rounded mb-4 w-full"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
          </div>
          <table className="table table-bordered dataTable" id="datatable">
            <thead>
              <tr>
                <th>Actions</th>
                <th>S. No.</th>
                <th>URL</th>
                <th title="Doamin Renewal">Renewal</th>
                <th title="Invoice Renewal">Invoice</th>
                <th title="Website Price">Price</th>
                <th title="Renewal Price">Renewal</th>
                <th>Server</th>
                <th>Email</th>
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((website, index) => (
                <tr key={website.id}>
                  <td>
                    <a href="#" data-bs-toggle="modal" data-bs-target="#edit_website" onClick={() => handleEditClick(website)}
                    >
                      <i className="fas fa-edit text-success ms-3"></i>
                    </a>
                    <button className="btn p-0 border-0 bg-transparent" onClick={() => handleDeleteClick(website.id)}
                    >
                      <i className="fas fa-trash text-primary ms-3"></i>
                    </button>
                  </td>
                  <td> {((currentPage-1)*itemsPerPage)+(index + 1)}</td>
                  <td>{website.websiteurl}</td>
                  <td>{website.domain_renewal_date < moment().add(1, 'months').format("YYYY-MM-DD") ? (<span className={`badge
            bg-inactive`}>{toCamelCase(website.domain_renewal_date)}</span>
                  ) : <span>{toCamelCase(website.domain_renewal_date)}</span>
                  }</td>
                  <td>{website.invoice_renewal_date < moment().add(1, 'months').format("YYYY-MM-DD") ? (<span className={`badge
            bg-inactive`}>{toCamelCase(website.invoice_renewal_date)}</span>
                  ) : <span>{toCamelCase(website.invoice_renewal_date)}</span>
                  }</td>
                  <td>{website.amount}</td>
                  <td>{website.renewal_amount}</td>
                  <td>{website.server}</td>
                  <td>{website.mail}</td>
                  <td>{toCamelCase(website.remarks)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="flex justify-center mt-4">
            <button
              className="px-3 py-1 mx-1 border rounded disabled:opacity-50"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Prev
            </button>
            <span className="px-3 py-1">Page {currentPage} of {totalPages}</span>
            <button
              className="px-3 py-1 mx-1 border rounded disabled:opacity-50"
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>

        </div>

      )}


      {/* Add and Edit Website Modals (omitted for brevity) */}
      <Add_Website />
      <Edit_Website
        website={selectedWebsite}
        onClientUpdated={() => setSelectedWebsite(null)}
      />
    </div>
  );
};

export default Website_Comp;
